import { jsx as l } from "react/jsx-runtime";
const i = (e) => l("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "1.5em", height: "1.5em", fill: "currentColor", viewBox: "0 0 24 24", focusable: "false", "aria-hidden": "true" }, e, { children: l("path", { fill: "inherit", d: "m8.4 17.275 3.2-1.9 3.225 1.9-.85-3.6L16.75 11.3l-3.675-.325L11.6 7.55l-1.475 3.425-3.675.325 2.8 2.375zM5.675 21l1.575-6.65L2 9.875l6.9-.6L11.6 3l2.7 6.3 6.9.575-5.25 4.475L17.525 21 11.6 17.475z" }) }));
export {
  i as default
};
